import { EventEmitter, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { RoleName } from '../@shared/constants/Constant';
import { ILoggedInUserViewModel } from '../model/common.model';
import { UserRoleEnum } from '@enums/user-role.enum';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  public isLoggedIn: boolean;
  public receivedLoginStatus: EventEmitter<boolean>;
  public isDownloadButtonShowSubject$ = new BehaviorSubject<boolean>(false);
  public isDownloadButtonShowAction$ = this.isDownloadButtonShowSubject$.asObservable();
  public moblieDeviceToggle = new Subject<any>();

  constructor(private router: Router) {
    this.receivedLoginStatus = new EventEmitter<boolean>();
  }

  raiseEvent(isLoggedIn: boolean): void {
    this.isLoggedIn = isLoggedIn;
    this.receivedLoginStatus.emit(isLoggedIn);
  }

  public redirectToRespectiveDashboard(role: string): void {
    switch (role) {
      case UserRoleEnum.EXECUTIVE_ADMIN:
      case UserRoleEnum.MANAGEMENT:
      case UserRoleEnum.COORDINATOR:
      case UserRoleEnum.INTERNAL_READONLY:
      case UserRoleEnum.ACCOUNTING:
        this.router.navigate(['/service-request']);
        break;
      case UserRoleEnum.VENDOR_DRIVER: //TODO:If we put multiple cases simultaneously without the break statement it will act as OR operator
      case UserRoleEnum.DRIVER:
        this.router.navigate(['/v2/driver-scheduling']);
        break;
      case UserRoleEnum.VENDOR_ADMIN:
      case UserRoleEnum.VENDOR_COORDINATOR:
        this.router.navigate(['/vendor-dashboard']);
        break;
      case UserRoleEnum.CUSTOMER_ADMIN:
      case UserRoleEnum.CUSTOMER_COORDINATOR:
        this.router.navigate(['/v2/customer-dashboard']);
        break;
      default:
        this.router.navigate(['/login']);
        break;
    }
  }

  /**
   * Redirect to the dashboard page depending on the current user role.
   * @param role - current user role
   *
   * @remarks
   * Refactored version of `redirectToRespectiveDashboard` that returns `Promise` and uses `UserRoleEnum`
   */
  public redirectToRespectiveDashboardV2(role: UserRoleEnum): Promise<boolean> {
    switch (role) {
      case UserRoleEnum.EXECUTIVE_ADMIN:
      case UserRoleEnum.MANAGEMENT:
      case UserRoleEnum.COORDINATOR:
      case UserRoleEnum.INTERNAL_READONLY:
      case UserRoleEnum.ACCOUNTING:
        return this.router.navigate(['/service-request']);
      case UserRoleEnum.VENDOR_DRIVER:
      case UserRoleEnum.DRIVER:
        return this.router.navigate(['/v2/driver-scheduling']);
      case UserRoleEnum.VENDOR_ADMIN:
      case UserRoleEnum.VENDOR_COORDINATOR:
        return this.router.navigate(['/vendor-dashboard']);
      case UserRoleEnum.CUSTOMER_ADMIN:
      case UserRoleEnum.CUSTOMER_COORDINATOR:
        return this.router.navigate(['/v2/customer-dashboard']);
      default:
        return this.router.navigate(['/login']);
    }
  }
}
